export const FETCH_WEBCHAT_WIDGETS_REQUEST =
  'WEBCHAT/FETCH_WEBCHAT_WIDGETS_REQUEST';
export const FETCH_WEBCHAT_WIDGETS_SUCCESS =
  'WEBCHAT/FETCH_WEBCHAT_WIDGETS_SUCCESS';
export const FETCH_WEBCHAT_WIDGETS_FAILURE =
  'WEBCHAT/FETCH_WEBCHAT_WIDGETS_FAILURE';

export const FETCH_WEBCHAT_ORG_STATUS_REQUEST =
  'WEBCHAT/FETCH_WEBCHAT_ORG_STATUS_REQUEST';
export const FETCH_WEBCHAT_ORG_STATUS_SUCCESS =
  'WEBCHAT/FETCH_WEBCHAT_ORG_STATUS_SUCCESS';
export const FETCH_WEBCHAT_ORG_STATUS_FAILURE =
  'WEBCHAT/FETCH_WEBCHAT_ORG_STATUS_FAILURE';

export const WEBCHAT_REACTIVATE_ORG_REQUEST =
  'WEBCHAT/WEBCHAT_REACTIVATE_ORG_REQUEST';
export const WEBCHAT_REACTIVATE_ORG_SUCCESS =
  'WEBCHAT/WEBCHAT_REACTIVATE_ORG_SUCCESS';
export const WEBCHAT_REACTIVATE_ORG_FAILURE =
  'WEBCHAT/WEBCHAT_REACTIVATE_ORG_FAILURE';

export const WEBCHAT_SUSPEND_ORG_REQUEST =
  'WEBCHAT/WEBCHAT_SUSPEND_ORG_REQUEST';
export const WEBCHAT_SUSPEND_ORG_SUCCESS =
  'WEBCHAT/WEBCHAT_SUSPEND_ORG_SUCCESS';
export const WEBCHAT_SUSPEND_ORG_FAILURE =
  'WEBCHAT/WEBCHAT_SUSPEND_ORG_FAILURE';

export const WEBCHAT_REMOVE_ORG_REQUEST = 'WEBCHAT/WEBCHAT_REMOVE_ORG_REQUEST';
export const WEBCHAT_REMOVE_ORG_SUCCESS = 'WEBCHAT/WEBCHAT_REMOVE_ORG_SUCCESS';
export const WEBCHAT_REMOVE_ORG_FAILURE = 'WEBCHAT/WEBCHAT_REMOVE_ORG_FAILURE';

export const WEBCHAT_GENERATE_SCRIPT_REQUEST =
  'WEBCHAT/WEBCHAT_GENERATE_SCRIPT_REQUEST';
export const WEBCHAT_GENERATE_SCRIPT_SUCCESS =
  'WEBCHAT/WEBCHAT_GENERATE_SCRIPT_SUCCESS';
export const WEBCHAT_GENERATE_SCRIPT_FAILURE =
  'WEBCHAT/WEBCHAT_GENERATE_SCRIPT_FAILURE';

export const WEBCHAT_UPDATE_SETTINGS_REQUEST =
  'WEBCHAT/WEBCHAT_UPDATE_SETTINGS_REQUEST';
export const WEBCHAT_UPDATE_SETTINGS_SUCCESS =
  'WEBCHAT/WEBCHAT_UPDATE_SETTINGS_SUCCESS';
export const WEBCHAT_UPDATE_SETTINGS_FAILURE =
  'WEBCHAT/WEBCHAT_UPDATE_SETTINGS_FAILURE';

export const WEBCHAT_ARCHIVE_WIDGET_REQUEST =
  'WEBCHAT/WEBCHAT_ARCHIVE_WIDGET_REQUEST';
export const WEBCHAT_ARCHIVE_WIDGET_SUCCESS =
  'WEBCHAT/WEBCHAT_ARCHIVE_WIDGET_SUCCESS';
export const WEBCHAT_ARCHIVE_WIDGET_FAILURE =
  'WEBCHAT/WEBCHAT_ARCHIVE_WIDGET_FAILURE';

export const WEBCHAT_UNARCHIVE_WIDGET_REQUEST =
  'WEBCHAT/WEBCHAT_UNARCHIVE_WIDGET_REQUEST';
export const WEBCHAT_UNARCHIVE_WIDGET_SUCCESS =
  'WEBCHAT/WEBCHAT_UNARCHIVE_WIDGET_SUCCESS';
export const WEBCHAT_UNARCHIVE_WIDGET_FAILURE =
  'WEBCHAT/WEBCHAT_UNARCHIVE_WIDGET_FAILURE';

export const WEBCHAT_SEND_EMAILS_REQUEST =
  'WEBCHAT/WEBCHAT_SEND_EMAILS_REQUEST';
export const WEBCHAT_SEND_EMAILS_SUCCESS =
  'WEBCHAT/WEBCHAT_SEND_EMAILS_SUCCESS';
export const WEBCHAT_SEND_EMAILS_FAILURE =
  'WEBCHAT/WEBCHAT_SEND_EMAILS_FAILURE';

export const WEBCHAT_WIDGET_SETTINGS_TYPES_REQUEST =
  'WEBCHAT/WEBCHAT_WIDGET_SETTINGS_TYPES_REQUEST';
export const WEBCHAT_WIDGET_SETTINGS_TYPES_SUCCESS =
  'WEBCHAT/WEBCHAT_WIDGET_SETTINGS_TYPES_SUCCESS';
export const WEBCHAT_WIDGET_SETTINGS_TYPES_FAILURE =
  'WEBCHAT/WEBCHAT_WIDGET_SETTINGS_TYPES_FAILURE';
